<template>
  <div>
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업 현황</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업공정</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_1" />
        </div>
        <div>
          <div>담당부서</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_2 " />
        </div>
        <div>
          <div>작업시간</div>
          <div class="time">
            <time-selector v-model="work.inputA_3" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="work.inputA_4" :readonly="board.readonly" />
          </div>
        </div>

        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_5 " />
        </div>
        <div>
          <div>신호</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_6 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_6 " />
        </div>
        <div class="hidden xl:block"></div>

        <div class="writeGridLineItem">
          <div>작업내용</div>
          <span v-if="isPrint" class="print-textarea"> {{ work.inputA_7 }} </span>
          <ml-textarea v-else rows="5" v-model="work.inputA_7" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="작업인원 <span style='color:#4839EB;'>※유도자(신호)는 작업지휘자와 중복 지정 가능</span>"
      title-type="html"
      :tableData="[
        { id: 'input1', title: '직책', type: 'text', placeholder: '' },
        { id: 'input2', title: '성명', type: 'text', placeholder: '' },
        { id: 'input3', title: '연락처', type: 'text', placeholder: '' },
        {
          id: 'input4',
          title: '보호구 지급',
          type: 'select',
          selectData: [
            '지급',
            '미지급',
          ],
          placeholder: '선택',
        },
        { id: 'input5', title: '필요자격여부', type: 'textarea', placeholder: '' },
      ]"
      :mobile="['input1', 'input2']"
      v-model="work.workerList"
      class="mt-4"
    />

    <div class="mt-8px">
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>작업자 준수사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ work.workerComment }} </span>
          <ml-textarea v-else rows="5" v-model="work.workerComment" :readonly="board.readonly" />
        </div>
      </div>
    </div>


    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기계제원<span style="color: #4839EB; font-size: 15px;">※ 사용 기계별 작성</span></h5>
      <div class="writeGridContainer">
        <div>
          <div>차량종류</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_1" placeholder="압착진개차, 음식물수거차, 진개덤프, 암롤트럭" />
        </div>
        <div>
          <div>차량번호</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_2" placeholder="대구00가0000" />
        </div>
        <div>
          <div>차량 최대적재 하중</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_3" />
          &nbsp;&nbsp;ton
        </div>

        <div>
          <div>제한속도</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_4" />
          &nbsp;&nbsp;km/h
        </div>
        <div>
          <div>보험 기한</div>
          <div class="time">
            <date-selector v-model="work.inputB_5" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="work.inputB_6" :readonly="board.readonly" />
          </div>
        </div>
        <div>
          <div>검사 기한</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_7 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputB_7" placeholder="자동차 검사, 안전검사 등" />
        </div>

      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 재해예방대책<span style="color: #4839EB; font-size: 15px;">※ 해당 사항은 예시 항목으로 실제 현장의 위험요인을 반영해 작성</span></h5>
      <div>
        <table>
          <colgroup>
            <col width="200" />
            <col />
            <col />
            <col width="300" />
          </colgroup>
          <thead>
            <tr>
              <th>구분</th>
              <th>유해·위험요인</th>
              <th>재해예방대책</th>
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>작업 전 점검사항</th>
              <td colspan="2" class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_1_1" :readonly="board.readonly" placeholder="예) 보호구 지급·착용 상태 확인"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_1_2" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>추락 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_2_1" :readonly="board.readonly" placeholder="예) 수거차량의 측면, 후면 등에 설치된 발판에 탑승하여 추락"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_2_2" :readonly="board.readonly" placeholder="예) 승차석이외의 적재함 내 탑승 후 이동 금지"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_2_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>낙하물 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_3_1" :readonly="board.readonly" placeholder="예) 상·하역 작업 시 보행자 접근하여 낙하물에 깔림"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_3_2" :readonly="board.readonly" placeholder="예) 상·하역 작업 시 작업자 외 접근금지 등 안전거리 확보 후 작업 실시"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_3_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>전도 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_4_1" :readonly="board.readonly" placeholder="예) 차량 운전 자격 없는 운전자의 운전미숙으로 인한 전도"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_4_2" :readonly="board.readonly" placeholder="예) 지정된 운전자 외의 운전자 차량 조작 금지"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_4_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>협착, 붕괴 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_5_1" :readonly="board.readonly" placeholder="예) 운행 중인 차량의 작업자 미확인으로 인한 협착"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_5_2" :readonly="board.readonly" placeholder="예) 모든 작업자들은 식별용조끼 착용 등 식별이 용이한 복장 착용"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_5_3" :readonly="board.readonly" />
              </td>
            </tr>

            <tr>
              <th>근골겨계 질환 예방</th>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_6_1" :readonly="board.readonly" placeholder="예) 5kg 이상 중량물의 무리한 운반으로 인한 근골격계 질환 발생"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_6_2" :readonly="board.readonly" placeholder="예) 작업인원 충원, 중량물 5Kg 미만 소분"/>
              </td>
              <td class="p-1">
                <ml-textarea rows="5" v-model="work.inputC_6_3" :readonly="board.readonly" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업계획(운반순서·경로)</h5>
      <div>
        <table>
          <tbody>
          <tr>
            <th>범 례</th>
          </tr>
          <tr>
            <td>
              <div class="flex" style="align-items: center; justify-content: center;">
                <p class="m-4">▣  장 비 </p>
                <p class="m-4">●  작 업 자</p>
                <p class="m-4">▲  신 호 수</p>
                <p class="m-4">★  작업지휘자 </p>
                <p class="m-4">→  이동경로</p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="grid grid-cols-12 h-upload">
                <div class="col-span-6 upload-content">
                  <div class="upload-content__file">
                    <FileUploader
                      v-if="!isPrint"
                      type="only-image"
                      v-model="work.inputD_1"
                    />
                    <img :src="work.inputD_1.thumb" v-else class="w-full h-full" />
                  </div>
                  <div class="pl-4 pr-4">
                    <ml-textarea rows="5" v-model="work.inputD_2" :readonly="board.readonly" placeholder="※ 운반경로(시점 ~종점 등) 명시
※ 운반경로 상 인력 배치 및 위험구간 표시
      - 위험 구간 및 유도자 배치 여부 등
      - 운반 중 작업자와 화물·기계 접촉 위험 구간 및 유도자 배치 여부 등
      - 현장 도면 등에 주요 위험구간 표시" />
                  </div>
                </div>
                <div class="col-span-6 upload-content">
                  <div class="upload-content__file">
                    <FileUploader
                      v-if="!isPrint"
                      type="only-image"
                      v-model="work.inputD_3"
                    />
                    <img :src="work.inputD_3.thumb" v-else class="w-full h-full" />
                  </div>
                  <div class="pl-4 pr-4">
                    <ml-textarea rows="5" v-model="work.inputD_4" :readonly="board.readonly" />
                  </div>
                </div>
              </div>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기타 붙임자료 등<span style="color: #4839EB; font-size: 15px;">※ 챠량등록증, 차량보험증서, 면허·자격증 ,참석자 명단 등</span></h5>
      <div>
        <table>
          <colgroup>
            <col width="200" />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th>구분</th>
            <th>작성 시 참고사항</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>작성 시기</th>
            <td>
              <div class="p-2" style="text-align: start;">
                <p>- 일상작업은 <b>최초 작업개시 전</b>에 작성</p>
                <p>- 작업장 내 <b>구조, 설비 및 작업방법이 변경</b>되었을 때 작성</p>
                <p>- <b>작업장소 또는 화물의 상태가 변경</b>되었을 때 작성</p>
                <p>- 작업장비의 <b>운전원 교체, 정기검사, 보험기한 연장 시</b> 재작성</p>
              </div>
            </td>
          </tr>
          <tr>
            <th>필수 첨부 서류</th>
            <td>
              <div class="p-2" style="text-align: start;">
                <p>- 차량계 하역운반기계 <b>등록증</b> (없는 경우 <b>장비안내서</b> 또는 <b>제원표</b>)</p>
                <p>- 차량계 하역운반기계 <b>검사증</b> (없는 경우 <b>안전인증서</b>)</p>
                <p>- 운전원 <b>면허증 사본</b></p>
                <p>- 차량<b>보험가입 증명서</b></p>
              </div>
            </td>
          </tr>
          <tr>
            <th>계획서 취급보관</th>
            <td>
              <div class="p-2" style="text-align: start;">
                <p>- 작성한 계획서의 <b>원본은 따로 분류</b>하여 보관</p>
                <p>- 계획서는 복사하여 <b>작업장비 별 비치</b> 필요</p>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "WorkCarry",
  components: {DateSelector, FileUploader, TableCustom, TimeSelector},
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    work: Object,
  },
  watch: {
    work: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.work.workerList || this.work.workerList.length === 0) {
          this.work.workerList = this.initWorkerList;
        }


        this.$emit("input", value);
      },
    },
  },
  mounted() {
    if (!this.work.inputD_1) {
      this.work.inputD_1 = { "id": 3382, "fileName": "Frame 6167.jpg", "fileSize": 125496, "path": "https://dgjg.maot.co.kr:8080/storage/app/uploads/public/658/3ea/719/6583ea7193665026428974.jpg", "thumb": "https://dgjg.maot.co.kr:8080/storage/app/uploads/public/658/3ea/719/6583ea7193665026428974.jpg" };
    }
  },
  data() {
    return {
      initWorkerList: [
        { input1: "작업지휘자", input2: "김안전", input3: "", input4: "", input5: "해당없음",},
        { input1: "유도자(신호)", input2: "김안전", input3: "", input4: "", input5: "단, 작업구간 지휘할 수있는 지위에\n있는 사람으로 중복 선임",},
        { input1: "작업자①", input2: "", input3: "", input4: "", input5: "해당없음",},
        { input1: "작업자②", input2: "", input3: "", input4: "", input5: "해당없음",},
        { input1: "운전자①", input2: "김운전", input3: "", input4: "", input5: "1종 보통 운전면허",},
        { input1: "운전자②", input2: "박운전", input3: "", input4: "", input5: "1종 보통 운전면허",},
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    text-align: center;
    min-height: 60px;
    height: 60px;
    font-size: 14px;
  }
  th {
    background-color: #f9f9f9;
    font-weight: 500;
    padding: 0;
    word-break: keep-all;
  }
  td {
    min-width: 50px;
    word-break: keep-all;
    img {
      display: inline-block;
    }
  }
  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }
  .check-container {
    padding: 10px 14px 0 14px;
    text-align: left;

    div {
      margin-bottom: 8px;
    }
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text-left {
    text-align: left;
    padding: 10px 14px;
  }
}
.print-break {
  break-inside: avoid;
}
.print-break-page {
  page-break-before: always;
}


/* uploaded File */

.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }
}
</style>
